import clsx from 'clsx';
import { type RefObject } from 'react';
import { Icon } from '../icon/icon.component';
import { type Style, mergeStyle } from './option-button.module.css';

interface Props {
  className?: Style;
  icon?: string;
  title: string;
  rightIcon?: string;
  optionRef?: RefObject<HTMLDivElement | null>;
  disabled?: boolean;
  onClick?: () => void;
}

export function OptionButton(props: Props) {

  const {
    className,
    icon,
    title,
    rightIcon,
    optionRef,
    disabled = false,
    onClick
  } = props;

  const style = mergeStyle(className);

  function handleClick() {
    if (!disabled) onClick?.();
  }

  return (
    <div 
      ref={optionRef}
      className={clsx(style.container, disabled && style.disabled)}
      onClick={handleClick}>
      {icon && <Icon
        className={style.icon} 
        icon={icon}/>}
      <span 
        className={clsx(style.title, !rightIcon && style.margin12px)}>
        {title}
      </span>
      {rightIcon &&
        <Icon 
          className={clsx(style.iconRight)} 
          icon={rightIcon}/>
      }
    </div>
  );
}
